import * as Sentry from '@sentry/react';

export const parseZoomURL = (url: string): { meetingNumber: string; password: string } | null => {
  try {
    const urlObj = new URL(url);
    const pathParts = urlObj.pathname.split('/');
    const meetingNumber = pathParts[pathParts.length - 1];

    const password = urlObj.searchParams.get('pwd') || '';

    if (!meetingNumber || !password) {
      Sentry.captureMessage('Missing meeting number or password in Zoom URL');
      return null;
    }

    return { meetingNumber, password };
  } catch (error) {
    Sentry.captureException(error, { extra: { url } });
    return null;
  }
};
